export default __webpack_public_path__ + "static/media/community.03720192.svg";